// extracted by mini-css-extract-plugin
export var border = "_o-7";
export var brand = "_o-s";
export var button = "_o-k";
export var center = "_o-9";
export var centered = "_o-5";
export var closeButton = "_o-b";
export var disabledWrapper = "_o-l";
export var error = "_o-o";
export var extraLarge = "_o-4";
export var extraSmall = "_o-1";
export var fill = "_o-h";
export var footer = "_o-g";
export var footerAction = "_o-i";
export var footerButtons = "_o-j";
export var header = "_o-6";
export var headerWithClose = "_o-c";
export var icon = "_o-n";
export var info = "_o-r";
export var inline = "_o-8";
export var large = "_o-3";
export var main = "_o-d";
export var modal = "_o-0";
export var neutral = "_o-t";
export var noPadding = "_o-f";
export var none = "_o-u";
export var scrollable = "_o-e";
export var small = "_o-2";
export var success = "_o-q";
export var tight = "_o-m";
export var titleIcon = "_o-a";
export var warn = "_o-p";